import React, { useState, useEffect, useMemo, useCallback } from "react";
import Col from "react-bootstrap/Col";
import { FaArrowRight } from "react-icons/fa";
import Nav from "react-bootstrap/Nav";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { getTitlePdf } from "app/_services/ehs/helpManual";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { getAuthUser } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
function ViewHelpManualFile() {
  const [helpManual, setHelpManual] = useState([]);
  const [activeKey, setActiveKey] = useState();
  const getHelpManualList = async () => {
    const response = await getTitlePdf();
    if (!response?.status) return;
    let data = response?.data || [];
    let auth_user = getAuthUser();
    console.log("auth_user", auth_user);
    data = data.filter(d => {
      if (auth_user?.role?.roleLable !== 1 && d.forAdmins && auth_user?.role?.roleLable !== 3 && auth_user?.role?.roleLable !== 2) {
        return false;
      }
      return true;
    });
    setHelpManual(data);
  };
  useEffect(() => {
    getHelpManualList();
  }, []);
  function TabTitle({ title, fields, active }) {
    const status = useMemo(() => { }, [fields]);

    return (
      <div className="d-flex justify-content-between pointer">
        <div>{title}</div>
        <div className={active ? "tabActive" : "mr-tab"}>
          <FaArrowRight />
        </div>
      </div>
    );
  }

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Help Manual", path: "#" },
          { name: "View ", path: "#" },
        ]}
      />
      <Tab.Container defaultActiveKey={"0"} activeKey={activeKey} onSelect={setActiveKey}>
        <Row>
          <Col xs={12} sm={6} md={3} lg={3} className="px-0 my-1">
            <Nav
              variant="pills"
              className="flex-column p-1 border rounded mx-1"
              style={{ minHeight: '100%' }}
            >
              {helpManual.length > 0 ? (
                <>
                  {Object.keys(helpManual).map((key) => (
                    <Nav.Item key={key}>
                      <Nav.Link eventKey={key}>
                        <TabTitle
                          title={helpManual[key].title}
                          fields={helpManual[key].document}
                          active={activeKey === key}
                        />
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </>
              ) : (
                <>
                  <h5 className="text-center">No Data exists</h5>
                </>
              )}
            </Nav>
          </Col>
          <Col xs={12} sm={6} md={9} lg={9} className="px-0 my-1">
            <Tab.Content className="p-2 border rounded mx-1" style={{ minHeight: 350 }}>
              {helpManual.length > 0 ? (
                <>
                  {Object.keys(helpManual).map((key) => (
                    <Tab.Pane eventKey={key} key={key}>
                      <div className="row mx-0">
                        <iframe
                          src={
                            URL_CONFIG.IMG_URL + helpManual[key].document.document_name
                          }
                          style={{
                            height: 700,
                            width: "100%",
                          }}
                        />
                      </div>
                    </Tab.Pane>
                  ))}
                </>
              ) : (
                <>
                  <h5 className="text-center">No Data exists</h5>
                </>
              )}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default ViewHelpManualFile;
